import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";
import type { ApiResponse } from "../types/api";

export interface Industry {
  name: string;
  name_ar?: string;
  status?: boolean;
}

export type IndustryUpdateBody = Partial<Industry>;

interface IndustriesListResponse {
  data: Array<Industry & { _id: string; createdAt?: string }>;
}

export const industriesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllIndustries: builder.query<
      ApiResponse<IndustriesListResponse>,
      void
    >({
      query: () => ({
        url: `${END_POINTS.industries}`,
        method: "GET",
      }),
    }),
    getIndustryById: builder.query<
      ApiResponse<Industry & { _id: string }>,
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.industries}/${id}`,
        method: "GET",
      }),
    }),
    createIndustry: builder.mutation<ApiResponse<Industry & { _id: string }>, { data: Industry }>({
      query: (body) => ({
        url: END_POINTS.industries,
        method: "POST",
        body: body?.data,
      }),
    }),
    updateIndustry: builder.mutation<
      ApiResponse<Industry & { _id: string }>,
      { id: string; body: IndustryUpdateBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.industries}/${id}`,
        method: "PUT",
        body: body,
      }),
    }),
    deleteIndustry: builder.query<
      ApiResponse<{ _id: string }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.industries}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllIndustriesQuery,
  useLazyGetIndustryByIdQuery,
  useCreateIndustryMutation,
  useUpdateIndustryMutation,
  useLazyDeleteIndustryQuery,
} = industriesApi;
